import { create } from "zustand";

type DismissedByJob = Record<string, Record<string, boolean>>;

interface JobLogWarningsStore {
  dismissed: DismissedByJob;
  dismiss: (jobId: string, warningKey: string) => void;
}

export const useJobLogWarningsStore = create<JobLogWarningsStore>()((set) => ({
  dismissed: {},
  dismiss: (jobId, warningKey) =>
    set((state) => ({
      dismissed: {
        ...state.dismissed,
        [jobId]: { ...state.dismissed[jobId], [warningKey]: true },
      },
    })),
}));
